var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1l10 8 10-8","stroke":"#fff","strokeWidth":"2"}));
}

ArrowDown.defaultProps = {"width":"22","height":"11","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
